export default __webpack_public_path__ + "static/media/evaluation.a9c9ce3a.png";